import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import moment from 'moment'
import 'moment/dist/locale/de'

import de_DE from './languages/de_DE.json'
import en_US from './languages/en_US.json'

i18n.use(initReactI18next).init({
  lng: 'de_DE',
  fallbackLng: 'de_DE',
  resources: { de_DE: de_DE.de_DE, en_US: en_US.en_US },
  interpolation: { escapeValue: false },
  react: {
    useSuspense: false,
  },
})

i18n.on('languageChanged', lng => {
  const normalized = String(lng || 'de_DE')
    .replace('_', '-')
    .toLowerCase()
  moment.locale(normalized)
})

global.i18n = (...args) => i18n.t(...args)

global.i18n.changeLanguage = async lng => {
  await i18n.changeLanguage(lng)

  const session = global.WatchStorage?.session
  if (!session?.token) return

  fetch(`${global.WatchStorage.backendUrl}/api/v1/user`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.token}`,
    },
    body: JSON.stringify({ language: lng }),
  }).catch(() => {})
  session.language = lng
}

global.moment = moment

export default i18n
